import React, {useState} from 'react';
import Breadcrumb from '../../../common/breadcrumb';
import AdpUploadHoursBody from "./adpUploadHoursBody";
import LoadingIndicator from "../../../common/loadingIndicator";
import PayPeriodFormFilter from "../../../common/form-filters/PayPeriodFormFilter";

/**
 * Process Invoices Report Component
 * @returns {JSX.Element}
 * @constructor
 */
const ADPUploadHours = () => {
    const [tableData, setTableData] = useState([]);
    const [filters, setFilters] = useState({
        pay_period_id: '',
        isLoading: false,
        isSubmitted: false,
    });

    return (
        <>
            <Breadcrumb title="ADP Upload Hours" parent="Reports"/>
            <PayPeriodFormFilter {...{setFilters, setTableData, OnSubmitUrl:"getADPUploadHours"}}/>
            <AdpUploadHoursBody filters={filters} tableData={tableData} setTableData={setTableData}/>
            <LoadingIndicator isLoading={filters.isLoading}/>
        </>
    );
}

export default ADPUploadHours;
